import { render, staticRenderFns } from "./authorityList.vue?vue&type=template&id=0bab446d&scoped=true&lang=pug"
import script from "./authorityList.vue?vue&type=script&lang=js"
export * from "./authorityList.vue?vue&type=script&lang=js"
import style0 from "./authorityList.vue?vue&type=style&index=0&id=0bab446d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab446d",
  null
  
)

export default component.exports